import ReportControlRepository from "@/repositories/vns/ReportControlRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'reportControl',
    namespaced: true,
    state: {
        ...makeState(),
        reportControlsByVns: []
    },    
    getters: {
        ...makeGetters(),
        allByVns (state) {
            return state.reportControlsByVns
        }
    },
    mutations: {
        ...makeMutations(),
        setAllByVns (state, array) {
            state.reportControlsByVns = array
        },
    },
    actions: {
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await ReportControlRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data.vnsReportControls)
                if (response.data.data.meta && Object.keys(response.data.data.meta).length > 0){
                    commit('setPagination', response.data.data.meta)
                }
            })
            commit('setLoading', false)
        },
        async listByVns ({ commit }, id) {
            commit('setLoading', true)
            await ReportControlRepository.fetchByVns(id).then(response => {
                commit('setAllByVns', response.data.data)
            })
            commit('setLoading', false)
        }
    }
}
